module.exports = __webpack_public_path__ + "img/ladies_inquiry.591d74cd.png";